import { styled, SvgIcon } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";

export const StyledDatePicker = {
  DatePicker: styled(DatePicker)(({ theme }) => ({
    dialogActions: {},
  })),
};

export const StyledDateTimePicker = {
  Icon: styled(SvgIcon)(({ theme }) => ({
    color: "white",
  })),
};
